import { DateTime } from 'luxon'
import { DayStrategy } from './day_strategy'

export default class WeekStrategy extends DayStrategy {
  get unit() {
    return this._unit || 'week'
  }

  // private

  get autoDateStart() {
    return this.commercialDate(this.cwyear, this.cweekStart, 1) // Monday of the first week
  }

  get autoDateEnd() {
    return this.commercialDate(this.cwyear, this.cweekEnd, 7) // Sunday of the last week
  }

  get cweekEnd() {
    return this.fromDate.weekNumber - 1
  }

  get cweekStart() {
    return this.cweekEnd - (this.offsetForPeriod - 1)
  }

  get cwyear() {
    return this.fromDate.weekYear
  }

  buildPriorPeriod() {
    return this.buildFor(this.fromDate.minus({ weeks: this.offsetForPeriod }))
  }

  // ISO weeks don't align perfectly across years, so re-anchor to the week
  // after the target range (cweekEnd + 1) in the prior year.
  buildPriorYear() {
    return this.buildFor(this.commercialDate(this.cwyear - 1, this.cweekEnd + 1, 1))
  }

  buildFor(fromDate) {
    let strategy = new this.constructor()
    strategy.period = this.period
    strategy.fromDate = fromDate

    return strategy
  }

  // Mirrors Ruby's Date.commercial(cwyear, cweek, cwday) using Luxon ISO week dates.
  commercialDate(weekYear, weekNumber, weekday) {
    return DateTime.fromObject({ weekYear, weekNumber, weekday })
  }
}

export { WeekStrategy }
